import script from "./BaseSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSpinner.vue?vue&type=script&setup=true&lang=js"

import "./BaseSpinner.vue?vue&type=style&index=0&id=0271d73f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/shark1x2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0271d73f"]])

export default __exports__